export const rl20white = {
  type: "spin",
  width: "20px",
  height: "20px",
  color: "white",
};

export const rl20golden = {
  type: "spin",
  width: "20px",
  height: "20px",
  color: "#d1bf7d",
};

export const rl24golden = {
  type: "spin",
  width: "24px",
  height: "24px",
  color: "#d1bf7d",
};

export const rl32golden = {
  type: "spin",
  width: "32px",
  height: "32px",
  color: "#d1bf7d",
};
